import {Color, Graphic, GraphicName} from '@benchling/nucleus-ui';
import {Carousel} from '@mantine/carousel';
import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {
  FONT_PROXIMA_13,
  FONT_WEIGHT_PROXIMA_REGULAR,
  FONT_WEIGHT_PROXIMA_SEMIBOLD,
} from 'styles/FontConstants';

export const TIME_SERIES_DESCRIPTION = 'Time-series graphs for your timepoint results.';
export const TIME_SERIES_ALT_TEXT =
  'Line chart showing numeric values over time for different unit operation instances.';

export const BAR_CHART_DESCRIPTION = 'Bar charts visualizing your test results.';
export const BAR_CHART_ALT_TEXT =
  'Bar chart comparing numeric results across entities or results. Each color group represents a unit operation instance.';

export const SUMMARY_TABLE_DESCRIPTION = 'Summary tables for your parameter and material input values.';
export const SUMMARY_TABLE_ALT_TEXT =
  'Table showing parameter and material input values for each unit operation instance.';

export default function OOTBChartingCarousel({description}: {description: string}): JSX.Element {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.carouselDescription)}>{description}</div>
      <Carousel
        slideSize="90%"
        slideGap={16}
        controlSize={32}
        withControls={true}
        withIndicators={true}
        controlsOffset={8}
      >
        <Carousel.Slide>
          <OOTBSlide
            description={TIME_SERIES_DESCRIPTION}
            graphicName="ootb-timeseries"
            graphicAltText={TIME_SERIES_ALT_TEXT}
          />
        </Carousel.Slide>
        <Carousel.Slide>
          <OOTBSlide
            description={BAR_CHART_DESCRIPTION}
            graphicName="ootb-bar-charts"
            graphicAltText={BAR_CHART_ALT_TEXT}
          />
        </Carousel.Slide>
        <Carousel.Slide>
          <OOTBSlide
            description={SUMMARY_TABLE_DESCRIPTION}
            graphicName="ootb-dataset"
            graphicAltText={SUMMARY_TABLE_ALT_TEXT}
          />
        </Carousel.Slide>
      </Carousel>
    </div>
  );
}

function OOTBSlide({
  description,
  graphicName,
  graphicAltText,
}: {
  description: string;
  graphicName: GraphicName;
  graphicAltText: string;
}): JSX.Element {
  return (
    <div className={css(styles.slideContainer)}>
      <Graphic
        name={graphicName}
        altText={graphicAltText}
        style={{width: '100%', height: '100%', flex: '1 1 auto'}}
      />
      <div className={css(styles.slideDescription)}>{description}</div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.GRAY_100,
    padding: '12px 16px',
  },
  carouselDescription: {
    ...FONT_PROXIMA_13,
    color: Color.GRAY_900,
    marginBottom: 16,
    fontWeight: FONT_WEIGHT_PROXIMA_SEMIBOLD,
  },
  slideContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'space-between',
    gap: 16,
    height: 296,
  },
  slideDescription: {
    ...FONT_PROXIMA_13,
    color: Color.GRAY_900,
    fontWeight: FONT_WEIGHT_PROXIMA_REGULAR,
    flex: '0 0 auto',
  },
});
